module.exports = __webpack_public_path__ + "img/lucy.069024dd.png";